import classNames from "classnames";
import {useEffect, useRef} from "react";

import {Checkbox} from "@/components/checkbox/Checkbox.tsx";
import {CheckboxInputProps} from "@/components/checkbox/CheckboxInput/CheckboxInput.tsx";

export const TableSelectionCheckBox = ({indeterminate, ...props}: {indeterminate?: boolean} & CheckboxInputProps) => {
  const ref = useRef<HTMLInputElement>(null!);

  useEffect(() => {
    if (typeof indeterminate === "boolean") {
      ref.current.indeterminate = !props.checked && indeterminate;
    }
  }, [ref, indeterminate, props.checked]);

  return (
    <Checkbox className={classNames("table-checkbox-cell align-content-center", props.className)}>
      <Checkbox.Input ref={ref} {...props} />
    </Checkbox>
  );
};
